import numeral from "numeral";

export default function formatFinancialValue(value: number | null, scale: "unit" | "thousand" = "thousand"): string {
  if (value === null) {
    return "0";
  }

  if (scale === "unit") {
    return (value / 1000 / 1000).toFixed(1).replace(".", ",");
  }

  // if (false) {
  //   return numeral(value * 1000 * 1000)
  //     .format("0.00a")
  //     .replace(".00", "");
  // }

  return numeral(value).format("0,000").replace(",", ".");
}
